import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["direction", "justifyContent", "children"];
import { Stack } from '@mui/material';
export var MuiStack = function (props) {
    var direction = props.direction, justifyContent = props.justifyContent, children = props.children, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Stack, _extends({
        direction: direction || 'row',
        justifyContent: justifyContent || 'center'
    }, other), children);
};
